import React from "react";
import "../styles/GuidedLearner.css";

const GuidedLearner = ({ features, limitations }) => {
  return (
    <div className="GuidedLearner">
      <div className="fw700">Quarterly Plan - “Guided Learner”</div>
      <div className="collections">
        <div className="collection1">
          <div className="info">
            <span className="fw700">Price:</span> $75 for 3 months (one-time and quarterly recurring, ($100 – 25% Discount))
          </div>
          <div className="info">
            <span className="fw700">Target Audience:</span> Students planning to study for a few months and prepare gradually for the SAT
          </div>
        </div>

        <div className="collection2">
          <div className="section-title">Features</div>
          {features && features.length > 0 ? (
            features.map((feature, index) => {
              const [title, text] = feature.split(":");
              return (
                <div key={index} className="feature">
                  <span className="fw700">{title}:</span> {text}
                </div>
              );
            })
          ) : (
            <div className="feature">No features available.</div>
          )}
        </div>

        <div className="collection3">
          <div className="limitations">
            <span className="fw700">Limitations:</span> {limitations}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidedLearner;
